import React from 'react';

const EMPTY_STYLE = {};

const Skeleton = ({ width = '100%', height = 16, style = EMPTY_STYLE, className = '' }) => {
  const merged = { width, height, ...style };
  return <span className={`skeleton ${className}`.trim()} style={merged} aria-hidden="true" />;
};

export const ProgressSkeletonItems = ({ labels, activeStep = 1 }) => (
  <>
    {labels.map((label, index) => (
      <React.Fragment key={label}>
        <div
          className={`progress-step${index + 1 === activeStep ? ' active' : ''}`}
          aria-hidden="true"
        >
          <span className="step-icon">{index + 1}</span>
          <Skeleton width={Math.max(label.length * 7, 42)} height={14} />
        </div>
        {index < labels.length - 1 ? <div className="progress-sep" aria-hidden="true" /> : null}
      </React.Fragment>
    ))}
  </>
);

export default Skeleton;
